<!-- Back to home -->
<div class="back-home">
  <button type="button" class="btn btn-sm pl-0 ml-0 mb-3" [routerLink]="'..'">
    <span><i class="icon icon-arrow-back-breadcrumb mr-1" aria-hidden="true"></i>HOME</span>
  </button>
</div>

<!-- Search info -->
<div class='search-info mt-2 mb-sm-2'>

</div>

<!-- Search dashboard -->
<div class="search-dashboard mb-5">

</div>
